import { IDataEndPoint, IEntityEndPoints, IFieldOptions, IFormOptions, IGridOptions, IColumnOptions, IEntityOptions } from '@framework/interfaces/IEntity';
import * as app from '@framework/app';
import * as models from '@common/domain/models/InvoiceDTO';
import { IApiServiceCommand } from '@services/api/api.service';
export class InvoiceEndPoints implements IEntityEndPoints {
	list?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/invoice"}, method: "GET" };
	get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/invoice/" + serviceCommand.context.entityId}, method: "GET" };
	update?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/invoice/update/" + serviceCommand.context.entityId}, method: "POST" };
	search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/invoice/lazy/"}, method: "POST" };
	pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/invoice/lazyCount/"}, method: "POST" };
	insert?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/invoice/create"}, method: "POST" };
	delete?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/invoice/delete/"+ serviceCommand.context.entityId}, method: "POST" };
}

export class InvoiceFormFields extends Array<IFieldOptions> {
	public id: IFieldOptions = { field: "id" };
	public jobCardId: IFieldOptions = { field: "jobCardId" };
	public deviationReasonId: IFieldOptions = { field: "deviationReasonId" };
	public dateSubmitted: IFieldOptions = { field: "dateSubmitted" };
	public dateReturned: IFieldOptions = { field: "dateReturned" };
	public replacementPONumber: IFieldOptions = { field: "replacementPONumber" };
	public dateToBudgetOwner: IFieldOptions = { field: "dateToBudgetOwner" };
	public dateRequested: IFieldOptions = { field: "dateRequested" };
	public dateRequesHonored: IFieldOptions = { field: "dateRequesHonored" };
	public planner: IFieldOptions = { field: "planner" };
	public dateProFormaSent: IFieldOptions = { field: "dateProFormaSent" };
	public dateInvoiceReceived: IFieldOptions = { field: "dateInvoiceReceived" };
	public invoiceNo: IFieldOptions = { field: "invoiceNo" };
	public creditNoteNo: IFieldOptions = { field: "creditNoteNo" };
	public dateSesSubmitted: IFieldOptions = { field: "dateSesSubmitted" };
	public dateSesSAccepted: IFieldOptions = { field: "dateSesSAccepted" };
	public sesNo: IFieldOptions = { field: "sesNo" };
	public datePaymentExpected: IFieldOptions = { field: "datePaymentExpected" };
	public datePaymentReceived: IFieldOptions = { field: "datePaymentReceived" };
	public remittanceNo: IFieldOptions = { field: "remittanceNo" };
	public invoiceWorkFlowStatusId: IFieldOptions = { field: "invoiceWorkFlowStatusId" };
	public finalInvoice: IFieldOptions = { field: "finalInvoice" };
	public status: IFieldOptions = { field: "status" };
	public datestamp: IFieldOptions = { field: "datestamp" };
	public changedBy: IFieldOptions = { field: "changedBy" };
	public amount: IFieldOptions = { field: "amount" };
	public headOfficeInvoiceNo: IFieldOptions = { field: "headOfficeInvoiceNo" };
	public headOfficeJobNo: IFieldOptions = { field: "headOfficeJobNo" };
	public headOfficeInvoiceAmount: IFieldOptions = { field: "headOfficeInvoiceAmount" };
	public invoiceStatusId: IFieldOptions = { field: "invoiceStatusId" };
	public headOfficeInvoiceWorkFlowStatusId: IFieldOptions = { field: "headOfficeInvoiceWorkFlowStatusId" };
	public invoicePeriodStart: IFieldOptions = { field: "invoicePeriodStart" };
	public invoicePeriodEnd: IFieldOptions = { field: "invoicePeriodEnd" };
	public previousClaimsAmount: IFieldOptions = { field: "previousClaimsAmount" };
	public requestTypeId: IFieldOptions = { field: "requestTypeId" };
	public dateInvoiceProcessed: IFieldOptions = { field: "dateInvoiceProcessed" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.jobCardId);
		this.push(this.deviationReasonId);
		this.push(this.dateSubmitted);
		this.push(this.dateReturned);
		this.push(this.replacementPONumber);
		this.push(this.dateToBudgetOwner);
		this.push(this.dateRequested);
		this.push(this.dateRequesHonored);
		this.push(this.planner);
		this.push(this.dateProFormaSent);
		this.push(this.dateInvoiceReceived);
		this.push(this.invoiceNo);
		this.push(this.creditNoteNo);
		this.push(this.dateSesSubmitted);
		this.push(this.dateSesSAccepted);
		this.push(this.sesNo);
		this.push(this.datePaymentExpected);
		this.push(this.datePaymentReceived);
		this.push(this.remittanceNo);
		this.push(this.invoiceWorkFlowStatusId);
		this.push(this.finalInvoice);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedBy);
		this.push(this.amount);
		this.push(this.headOfficeInvoiceNo);
		this.push(this.headOfficeJobNo);
		this.push(this.headOfficeInvoiceAmount);
		this.push(this.invoiceStatusId);
		this.push(this.headOfficeInvoiceWorkFlowStatusId);
		this.push(this.invoicePeriodStart);
		this.push(this.invoicePeriodEnd);
		this.push(this.previousClaimsAmount);
		this.push(this.requestTypeId);
		this.push(this.dateInvoiceProcessed);
	}
}

export class InvoiceForm implements IFormOptions {
	protected invoiceFormName: string = "invoiceForm";
	protected invoiceFormModel: models.InvoiceDTO = new models.InvoiceDTO();
	protected invoiceFormEndPoints: InvoiceEndPoints = new InvoiceEndPoints();
	protected invoiceFormFields: InvoiceFormFields = new InvoiceFormFields();
	public get name(): string { return this.invoiceFormName };
	public get model(): models.InvoiceDTO { return this.invoiceFormModel };
	public get endPoints(): IEntityEndPoints { return this.invoiceFormEndPoints };
       public set endPoints(invoiceEndPoints: IEntityEndPoints) {
		this.invoiceFormEndPoints = invoiceEndPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.get };
	public get fields(): InvoiceFormFields { return this.invoiceFormFields };
}

export class InvoiceListColumns extends Array<IColumnOptions> {
	public id: IColumnOptions = { field: "id" };
	public jobCardId: IColumnOptions = { field: "jobCardId" };
	public deviationReasonId: IColumnOptions = { field: "deviationReasonId" };
	public dateSubmitted: IColumnOptions = { field: "dateSubmitted", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public dateReturned: IColumnOptions = { field: "dateReturned", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public replacementPONumber: IColumnOptions = { field: "replacementPONumber" };
	public dateToBudgetOwner: IColumnOptions = { field: "dateToBudgetOwner", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public dateRequested: IColumnOptions = { field: "dateRequested", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public dateRequesHonored: IColumnOptions = { field: "dateRequesHonored", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public planner: IColumnOptions = { field: "planner" };
	public dateProFormaSent: IColumnOptions = { field: "dateProFormaSent", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public dateInvoiceReceived: IColumnOptions = { field: "dateInvoiceReceived", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public invoiceNo: IColumnOptions = { field: "invoiceNo" };
	public creditNoteNo: IColumnOptions = { field: "creditNoteNo" };
	public dateSesSubmitted: IColumnOptions = { field: "dateSesSubmitted", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public dateSesSAccepted: IColumnOptions = { field: "dateSesSAccepted", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public sesNo: IColumnOptions = { field: "sesNo" };
	public datePaymentExpected: IColumnOptions = { field: "datePaymentExpected", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public datePaymentReceived: IColumnOptions = { field: "datePaymentReceived", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public remittanceNo: IColumnOptions = { field: "remittanceNo" };
	public invoiceWorkFlowStatusId: IColumnOptions = { field: "invoiceWorkFlowStatusId" };
	public finalInvoice: IColumnOptions = { field: "finalInvoice" };
	public status: IColumnOptions = { field: "status" };
	public datestamp: IColumnOptions = { field: "datestamp", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public changedBy: IColumnOptions = { field: "changedBy" };
	public amount: IColumnOptions = { field: "amount" };
	public headOfficeInvoiceNo: IColumnOptions = { field: "headOfficeInvoiceNo" };
	public headOfficeJobNo: IColumnOptions = { field: "headOfficeJobNo" };
	public headOfficeInvoiceAmount: IColumnOptions = { field: "headOfficeInvoiceAmount" };
	public invoiceStatusId: IColumnOptions = { field: "invoiceStatusId" };
	public headOfficeInvoiceWorkFlowStatusId: IColumnOptions = { field: "headOfficeInvoiceWorkFlowStatusId" };
	public invoicePeriodStart: IColumnOptions = { field: "invoicePeriodStart", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public invoicePeriodEnd: IColumnOptions = { field: "invoicePeriodEnd", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public previousClaimsAmount: IColumnOptions = { field: "previousClaimsAmount" };
	public requestTypeId: IColumnOptions = { field: "requestTypeId" };
	public dateInvoiceProcessed: IColumnOptions = { field: "dateInvoiceProcessed", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.jobCardId);
		this.push(this.deviationReasonId);
		this.push(this.dateSubmitted);
		this.push(this.dateReturned);
		this.push(this.replacementPONumber);
		this.push(this.dateToBudgetOwner);
		this.push(this.dateRequested);
		this.push(this.dateRequesHonored);
		this.push(this.planner);
		this.push(this.dateProFormaSent);
		this.push(this.dateInvoiceReceived);
		this.push(this.invoiceNo);
		this.push(this.creditNoteNo);
		this.push(this.dateSesSubmitted);
		this.push(this.dateSesSAccepted);
		this.push(this.sesNo);
		this.push(this.datePaymentExpected);
		this.push(this.datePaymentReceived);
		this.push(this.remittanceNo);
		this.push(this.invoiceWorkFlowStatusId);
		this.push(this.finalInvoice);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedBy);
		this.push(this.amount);
		this.push(this.headOfficeInvoiceNo);
		this.push(this.headOfficeJobNo);
		this.push(this.headOfficeInvoiceAmount);
		this.push(this.invoiceStatusId);
		this.push(this.headOfficeInvoiceWorkFlowStatusId);
		this.push(this.invoicePeriodStart);
		this.push(this.invoicePeriodEnd);
		this.push(this.previousClaimsAmount);
		this.push(this.requestTypeId);
		this.push(this.dateInvoiceProcessed);
	}
}

export class InvoiceList implements IGridOptions {
	protected invoiceListName: string = "invoiceList";
	protected invoiceListModel: models.InvoiceDTO = new models.InvoiceDTO();
	protected invoiceListEndPoints: InvoiceEndPoints = new InvoiceEndPoints();
	protected invoiceListColumns: InvoiceListColumns = new InvoiceListColumns();
	public invoiceForm: InvoiceForm = new InvoiceForm();
	public get name(): string { return this.invoiceListName };
	public get model(): models.InvoiceDTO { return this.invoiceListModel };
	public get endPoints(): IEntityEndPoints { return this.invoiceListEndPoints };
	public set endPoints(invoiceEndPoints: IEntityEndPoints) {
		this.invoiceListEndPoints = invoiceEndPoints;
		this.invoiceForm.endPoints = this.endPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
	public get columns(): InvoiceListColumns { return this.invoiceListColumns };
}

export class InvoiceEntity implements IEntityOptions {
	protected invoiceEntityName: string = "invoiceEntity";
	protected invoiceEntityModel: models.InvoiceDTO = new models.InvoiceDTO();
	protected invoiceEntityEndPoints: InvoiceEndPoints = new InvoiceEndPoints();
	protected invoiceEntityList: InvoiceList = new InvoiceList();
	public get name(): string { return this.invoiceEntityName };
	public get model(): models.InvoiceDTO { return this.invoiceEntityModel };
	public get endPoints(): IEntityEndPoints { return this.invoiceEntityEndPoints };
	public set endPoints(invoiceEndPoints: IEntityEndPoints) {
		this.invoiceEntityEndPoints = invoiceEndPoints;
		this.grid.endPoints = this.endPoints;
	};
	public get grid(): InvoiceList { return this.invoiceEntityList };
	public get form(): InvoiceForm { return this.grid.invoiceForm };
	constructor(name?: string) {
		if (name) this.invoiceEntityName = name;
		this.endPoints = this.invoiceEntityEndPoints;
	}
};
//export class InvoiceGeneratedForm extends MfGeneratedFormComponent {
 // protected detailPageComponentForm: InvoiceForm = new InvoiceForm();
//};

//export class InvoiceListPageComponent extends ListPageComponent {
  //protected listPageComponentList: InvoiceList = new  InvoiceList();
  //protected showFilterColOnTable: boolean = true;
//};

//export class InvoiceBlade extends MfBladeComponent {
  //protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: InvoiceGeneratedForm}];
//};

//export class InvoiceListBlade extends MfBladeComponent {
 // protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: InvoiceListPageComponent, isMenuHidden: true }];
//};

